<template>
  <div id="app">
    <header class="headerbar">
      <nav>
        <ul>
          <li class="nav-item">
            <!-- <router-link class="nav-link" :to="{name: 'SubmitRequest'}" exact> -->
            <a :href="this.rooturl">
              <img class="logo" width="139" height="61" src="https://healthplan.memorialhermann.org/assets/images/logo-healthplan.png" aria-hidden="true" />
            </a>
            <!-- </router-link> -->
          </li>
        </ul>
      </nav>
    </header>
    <main>
      <div>
        <h5 class="titleCaption">REQUEST TO PARTICIPATE</h5>
      </div>
      <router-view />
    </main>    
  </div>
</template>

<script>
export default {
  name: 'app',
 data() {
        return {
          rooturl: process.env.VUE_APP_PUBLIC_PATH
        } 
    },  
  components: {
  }
}
</script>

<style>
hr.titleBorder {
  border: 2px solid black;
  border-radius: 2px;
}
h5.titleCaption {
  font-weight: bolder;
}
body{
 background-attachment: fixed;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
main {
  margin: 0 auto;
  padding: 30px;
  background-color: white;
  width: 1184px;
  min-height: 300px;
}
header.headerbar {
  width: 1184px;
  margin: 0 auto;
}
ul {
  padding: 3px;
  display: flex;
}
.nav-item {
  display: inline-block;
  padding: 5px 10px;
  font-size: 22px;
}
.nav-item.cart {
  position: relative;
  margin-left: auto;
  border-right: none;
}
.logo {
  vertical-align: middle;
}
.nav-link {
  text-decoration: none;
  color: inherit;
  font-size: inherit;
}
.container {
  display: flex;
  margin: 10px auto 0 auto;
}
.aside {
  padding: 30px;
  background-color: #aaa;
  width: 100px;
  min-height: 300px;
}
.cart-items {
  position: absolute;
  top: -5px;
  right: -9px;
  font-size: 18px;
  width: 20px;
  text-align: center;
  display: inline-block;
  border-radius: 100px;
  background-color: mediumseagreen;
}</style>
